import { render, staticRenderFns } from "./Describe.vue?vue&type=template&id=a523c0b8&scoped=true"
import script from "./Describe.vue?vue&type=script&lang=js"
export * from "./Describe.vue?vue&type=script&lang=js"
import style0 from "./Describe.vue?vue&type=style&index=0&id=a523c0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a523c0b8",
  null
  
)

export default component.exports